import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-help-dialog',
  templateUrl: './search-help-dialog.component.html',
  styleUrls: ['./search-help-dialog.component.css'],
})
export class SearchHelpDialogComponent {
  helpType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { helpType: string },
    public dialogRef: MatDialogRef<SearchHelpDialogComponent>
  ) {
    this.helpType = data && data.helpType ? data.helpType : 'reference';
  }

  close(): void {
    this.dialogRef.close();
  }
}
